export default __webpack_public_path__ + "static/media/account_background.661185bb.jpg";